module.exports = __webpack_public_path__ + "static/media/1_A1_25.9bbb6ec1.png";